/* eslint-disable max-len */
import { CONSTANTS } from '@static/constants';

export const MESSAGES = {
    MIDIA_FORMAT_ERROR: 'Formato de vídeo inválido. Formatos permitidos mov ou mp4',
    UPLOAD_VIDEO_LIMIT_ERROR: 'Só pode ser adicionado um vídeo por anúncio',
    VIDEO_DURATION_LIMIT_ERROR: 'O vídeo tem que ter '+CONSTANTS.UPLOAD.VIDEO.DURATION_LIMIT+' segundos ou menos',
    UPLOAD_ERROR: 'Erro ao adicionar o arquivo',
};
